import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { NativeSelect } from "@/components/ui/native-select";

import { allowanceCopy as copy, type Form } from "./time-allowance-copy";

export interface CourseChoice {
  id: string;
  label: string;
}

export function AllowanceFields({ id, form, set, courses, disabled }: { id: string; form: Form; set: (patch: Partial<Form>) => void; courses: CourseChoice[]; disabled: boolean }) {
  return (
    <fieldset disabled={disabled} className="grid gap-4 disabled:opacity-80">
      <div className="grid gap-1.5">
        <Label htmlFor={`${id}-percent`}>{copy.percent}</Label>
        <Input id={`${id}-percent`} inputMode="numeric" className="w-28" value={form.percent} onChange={(event) => set({ percent: event.target.value.trim() })} />
      </div>
      <div className="grid gap-4 sm:grid-cols-2">
        <div className="grid gap-1.5">
          <Label htmlFor={`${id}-from`}>{copy.from}</Label>
          <Input id={`${id}-from`} type="date" className="w-auto" value={form.from} onChange={(event) => set({ from: event.target.value })} />
        </div>
        <div className="grid gap-1.5">
          <Label htmlFor={`${id}-until`}>{copy.until}</Label>
          <Input id={`${id}-until`} type="date" className="w-auto" value={form.until} onChange={(event) => set({ until: event.target.value })} />
        </div>
      </div>
      <div className="grid gap-1.5">
        <Label htmlFor={`${id}-scope`}>{copy.covers}</Label>
        <NativeSelect id={`${id}-scope`} value={form.scope} onChange={(event) => set({ scope: event.target.value as Form["scope"] })}>
          <option value="named">{copy.named}</option>
          <option value="all">{copy.all}</option>
        </NativeSelect>
      </div>
      {form.scope === "named" && (
        courses.length ? (
          <div className="grid gap-2" role="group" aria-label={copy.named}>
            {courses.map((course) => (
              <label key={course.id} className="flex items-center gap-2 text-ui">
                <Checkbox
                  checked={form.courses.includes(course.id)}
                  onCheckedChange={(on) => set({ courses: on === true ? [...form.courses, course.id] : form.courses.filter((each) => each !== course.id) })}
                />
                {course.label}
              </label>
            ))}
          </div>
        ) : <p className="text-ui text-muted-foreground">{copy.noCourses}</p>
      )}
      <div className="grid gap-4 sm:grid-cols-2">
        <div className="grid gap-1.5">
          <Label htmlFor={`${id}-approver`}>{copy.approver}</Label>
          <Input id={`${id}-approver`} value={form.approver} onChange={(event) => set({ approver: event.target.value })} />
        </div>
        <div className="grid gap-1.5">
          <Label htmlFor={`${id}-reference`}>{copy.reference}</Label>
          <Input id={`${id}-reference`} value={form.reference} onChange={(event) => set({ reference: event.target.value })} />
        </div>
      </div>
    </fieldset>
  );
}
